import { useState } from "react";
import { imageUrl, type ImagePreset } from "../lib/images";

type CatalogImageProps = {
  alt?: string;
  className: string;
  decorative?: boolean;
  preset: ImagePreset;
  storageKey: string;
};

export function CatalogImage({
  alt = "",
  className,
  decorative = false,
  preset,
  storageKey,
}: CatalogImageProps) {
  const [hasError, setHasError] = useState(false);
  const src = storageKey ? imageUrl(storageKey, preset) : "";

  if (!src || hasError) {
    const accessibleProps = decorative
      ? { "aria-hidden": true }
      : { "aria-label": alt || "Product image unavailable", role: "img" };

    return (
      <span
        className={`${className} image-placeholder`}
        {...accessibleProps}
      />
    );
  }

  return (
    <img
      className={className}
      src={src}
      alt={decorative ? "" : alt}
      onError={() => setHasError(true)}
    />
  );
}
